import { Component } from "react";
import { balikArtikleController } from "../../../controllers/balikartikle.controller";
import { Zvuky } from "../Zvuky";

/**
 * Komponenta pro přidání artiklu do balíku na základě naskenovaného čárového kódu
 *
 * @class GetArtikelFromCiarovyKod
 * @extends {Component}
 */
class GetArtikelFromCiarovyKod extends Component {
    componentDidMount() {
        var pokracovat = this.props.skenProgress != true;
        if (pokracovat && this.props.startRequest) {
            pokracovat = this.props.startRequest(); // Nastavit začátek skenování (zobrazit loading spinner)
        } else {
            Zvuky.playChyba(); // Pokud již skenování probíhá, tak přehrát zvuk chyby a naskenovaný kód zahodit
        }
        if (pokracovat) {
            // Předat skenovaný kód na server a po návratu spustit metodu getArtikel
            balikArtikleController.getArtikelByCiarovyKod(this.props.balik, this.props.cisloCiarovehoKodu).then((response) => {
                this.props.getArtikel(response);
            });
        }
    }

    render() {
        return null;
    }
}

export default GetArtikelFromCiarovyKod;



// WEBPACK FOOTER //
// ./src/components/common/SnimanieCiarovehoKodu/GetArtikelFromCiarovyKod.js